import React from 'react'
import { useSelector } from 'react-redux'
import { myOrganizationsSelector } from 'features/auth/authSlice'
import { useEventSlug } from 'hooks'
import Modal from 'react-bootstrap/cjs/Modal'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { _, colors } from '../../../utils'
import Icon from '../../Icon'
import routes from '../../../routes'

const S = {
    ModalHeader: styled(Modal.Header)`
        position: relative;
        padding: 30px;
        font-weight: 500;
        font-size: 30px;
        line-height: 35px;
        color: ${colors.dark};
        border-bottom: none;
        & button {
            position: absolute;
            top: 18px;
            right: 30px;
            color: ${colors.icon};
            font-size: 34px;
            font-weight: 400;
            opacity: 1 !important;
        }
    `,
    ModalBody: styled(Modal.Body)`
        padding: 0 30px 40px 30px;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        color: ${colors.grayDescription};

        a {
            color: inherit;
            text-decoration: none;
        }
    `,
    ListItem: styled.div`
        display: flex;
        justify-content: space-between;
        padding: 20px 16px;
        border: 1px solid #F4F5F6;

        :hover {
            color: #3068F4;
            cursor: pointer;
            
            path {
                fill: #3068F4 !important;
            }
        }
    `
}

type Props = {
    show
    handleClose
}
const OrganizationListModal = ({ show, handleClose }: Props) => {
    const eventSlug = useEventSlug()
    const organizations = useSelector(myOrganizationsSelector) || []

    return (
        <Modal centered show={show} onHide={() => handleClose()}>
            <S.ModalHeader closeButton>
                {_('top_navigation.organisation.modal.choose_organisation')}
            </S.ModalHeader>
            <S.ModalBody>
                <p>{_('top_navigation.organisation.modal.description')}</p>
                {organizations.map((organization) => (
                    <Link
                        key={organization.id}
                        to={{
                            pathname: routes.organization.getPath({ organizationId: `${organization.id}` }),
                            state: { eventSlug }
                        }}
                    >
                        <S.ListItem key={organization.id}>
                            <span>{organization.name}</span>
                            <Icon icon="arrowRight" color={colors.grayTitle} size={16} />
                        </S.ListItem>
                    </Link>
                ))}
            </S.ModalBody>
        </Modal>
    )
}

export default OrganizationListModal
